import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import './MENU.css';

// the menu component is not just a single menu, it is a whole hierarchy
class MENU extends PureComponent {
    static annotateAccelText(text, accel) {
        if (accel) {
            var accelIndex = text.indexOf(accel);
            return <div className="menu-text">
                {text.substring(0, accelIndex)}
                <span className="menu-item-accel">{accel}</span>
                {text.substring(accelIndex + 1)}
            </div>;
        } else {
            return <div className="menu-text">{text}</div>;
        }
    }

    constructor(props) {
        super(props);

        // first menubit is always root, starts out as visible
        this.state = this.parseMenu(props.menu);
    }

    componentWillReceiveProps(nextProps) {

        // first menubit is always root, starts out as visible
        this.setState(this.parseMenu(nextProps.menu));
    }

    parseMenu(menu) {
        var menuBits = this.toMenuBits(menu);

        return { 
            menuBits: menuBits,
            bit0Position: [this.props.top, this.props.right, this.props.bottom, this.props.left]
        };
    }

    toMenuBits(menu, key, depth) {
        var bits = [];
        var items = [];
        depth = depth || 0;

        var bit = {
            style: menu.style,
            direction: menu.direction,
            items: items,
            depth: depth
        };

        if (!key) {
            key = { value: 0 };
        }
        var myKey = key.value;
        key.value += 1;
        bits.push(bit);

        for (var i = 0; i < menu.items.length; i++) {
            var item = Object.assign({}, menu.items[i]);
            if (item.type == "menu") {
                item["menuKey"] = key.value;
                bits.push.apply(bits, this.toMenuBits(item, key, depth + 1));
                delete item.items;
            }
            bit.items.push(item);
        }
        return bits;
    }

    renderMenuItems(menuItems, depth) {
        var elms = [];

        var anyHasShortcut = false;
        for (var index = 0; index < menuItems.length; index++) {
            if (menuItems[index].shortcut) {
                anyHasShortcut = true;
                break;
            }
        }

        for (index = 0; index < menuItems.length; index++) {
            var menuItem = menuItems[index];

            var type = menuItem.type;
            if (!type) {
                type = "item";
            }

            var shortcut = null;
            if (anyHasShortcut) {
                shortcut = <div className="menu-item-shortcut">{menuItem.shortcut}</div>;
            }
    
            if (type == "divider") {
                elms.push(<div className="menu-divider" key={index}></div>);
            } else {
                var clazz = "menu-item menu-item-" + type;
                if (menuItem.disabled) {
                    clazz += " disabled";
                }

                // Accelerator keys
                var text = MENU.annotateAccelText(menuItem.text, menuItem.accel);

                var iconStyle = { backgroundImage: 'url(' + menuItem.icon + ')' };

                let item = menuItem;
                let clearOtherSubmenus = () => {
                    // Clear visible menubits with depth greater than ours
                    for (var i = 0; i < this.state.menuBits.length; i++) {
                        var menuBit = this.state.menuBits[i];
                        if (menuBit.depth > depth && this.state["bit" + i + "Position"]) {
                            var newState = {};
                            newState["bit"+i+"Position"] = null;
                            this.setState(newState);  
                        }
                    }
                    
                };

                var onMouseEnter = clearOtherSubmenus, onMouseExit = null;
                var onClick = (e) => {
                    if (this.props.onDismiss) {
                        this.props.onDismiss();
                    }
                    if (item.onclick) {
                        item.onclick();
                    }
                    e.stopPropagation();
                };

                if (menuItem.type == "menu") {

                    onMouseEnter = (e) => {
                        clearOtherSubmenus();

                        var newState = {};

                        // TODO compute menu position
                        var newPosition;

                        if (e.target.getBoundingClientRect().left + e.target.offsetWidth + 150 > window.innerWidth
                            && e.target.getBoundingClientRect().left > 150) {
                            newPosition = [e.target.getBoundingClientRect().top,
                                window.innerWidth - e.target.getBoundingClientRect().left,
                                null, null];
                        } else {
                            newPosition = [e.target.getBoundingClientRect().top, null,
                                null, e.target.getBoundingClientRect().left + e.target.offsetWidth];
                        }

                        newState[("bit" + item.menuKey + "Position")] = newPosition;
                        this.setState(newState);  
                    };
                    onMouseExit = () => {

                    };
                    onClick = (e) => {
                        e.stopPropagation();
                    };
                }

                elms.push(<div className={clazz} key={index} onClick={onClick}
                    onMouseEnter={onMouseEnter} onMouseExit={onMouseExit}>
                    <div className="menu-item-icon" style={iconStyle}></div>
                    {text}
                    {shortcut}
                </div>);
            }
        }

        return elms;
    }

    renderMenuBits(menuBits) {
        var elms = [];

        for (var i = 0; i < this.state.menuBits.length; i++) {
            var menuBit = this.state.menuBits[i];
            var clazz = "menu-bit";
            if (menuBit.style) {
                clazz += " menu-bit-style-" + menuBit.style;
            }

            let position = this.state[("bit" + i + "Position")];
            if (position) {
                // Render menu bit
                var css = {
                    top: position[0],
                    right: position[1],
                    bottom: position[2],
                    left: position[3],
                };
                var elm = <div className={clazz} id={"menu-bit-" + i} key={"menu-bit-" + i} style={css}>
                    {this.renderMenuItems(menuBit.items, menuBit.depth)}
                </div>;
                elms.push(elm);
            }
        }

        return elms;
    }

    render() {
        var renderedMenu = this.renderMenuBits(this.state.menuBits);

        return ReactDOM.createPortal(
            <div className="menu-container" onMouseDown={(e) => { e.stopPropagation(); }}>
                {renderedMenu}
            </div>,
        window.WINAPI.GetDesktopWindow());
    }
}

export default MENU;



// WEBPACK FOOTER //
// ./src/walleris/menus/MENU.js